import downArrow from '../../../assets/images/downArrow.svg'

const AdditionalInfoLayout = ({ layout, value }) => {
  //item, data, image, title
  console.log('>>>>>>>additional_info ' + value)
  return (
    <>
      {
        <div
          style={{
            padding: '16px 20px 32px 20px',
            background: layout.color ? `#${layout.color}` : '',
            background: '#f0f000',
          }}
        >
          <div>
            <img src={layout.iconName} alt={layout.iconName} />
          </div>
          <div
            style={{
              // marginTop: "55px",
              marginBottom: '20px',
              textAlign: 'left',
              fontWeight: 590,
              fontSize: '17px',
              lineHeight: '140%',
              color: '#0B0C15',
              letterSpacing: '-0.4px',
            }}
          >
            {layout.displayName}
          </div>
          <ul
            style={{
              padding: '0 5px 0 5px',
            }}
          >
            {/* {value &&
              value.map((item) => {
                return (
                  <li
                    style={{
                      fontWeight: 400,
                      fontSize: '16px',
                      lineHeight: '150%',
                      color: '#424450',
                      marginBottom: '20px',
                      listStyleType: item.style === 'none' ? 'none' : 'disc',
                      marginLeft: item.style === 'disc' ? '10px' : '0px',
                    }}
                  >
                    {item}
                  </li>
                )
              })} */}
          </ul>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: '18px',
            }}
          >
            <button
              style={{
                fontWeight: 590,
                fontSize: '15px',
                lineHeight: '150%',
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                letterSpacing: '-0.005em',
                color: '#00857D',
                border: 'none',
                background: 'white',
                paddingRight: 0,
                paddingLeft: 0,
              }}
            >
              See all
            </button>
            <img
              src={downArrow}
              alt=""
              style={{
                fontWeight: 590,
                fontSize: '15px',
                lineHeight: '150%',
              }}
            ></img>
          </div>
        </div>
      }
    </>
  )
}

export default AdditionalInfoLayout
